import React from 'react';
import { Box } from '@mui/material';

/**
 * 사용자 이름 및 이메일 셀 컴포넌트
 * 
 * 사용자 이름과 이메일을 함께 표시합니다.
 * 
 * @param {Object} params - DataGrid의 renderCell 파라미터
 * @param {Object} params.row - 행 데이터
 * @param {string} params.row.name - 사용자 이름
 * @param {string} params.row.email - 사용자 이메일
 */
const UserNameCell = ({ row }) => {
  return (
    <Box display="flex" gap={1}>
      <span>{row.name}</span>
      <span style={{ fontSize: '12px', color: '#888' }}>({row.email})</span>
    </Box>
  );
};

export default UserNameCell;
